var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};
MDB.DPN.Offers.Requests = MDB.DPN.Offers.Requests || {};
MDB.DPN.Offers.RequestLanding = MDB.DPN.Offers.RequestLanding || {};

(function ($) {
    var crudServiceBaseUrl = document.location.origin + '/api/DPN/Offers';
    
    function createRequestGrid(gridSelector) {
        var $gridSelector = $(gridSelector);
        
        var status = $gridSelector.data('status');
        var columnConfig = $gridSelector.data('grid-config');
        
        var boolFields = _.filter(Object.keys(columnConfig.model.fields), function(key){
            return columnConfig.model.fields[key].type === 'boolean';
        });
        
        var boolCols = _.filter(columnConfig.columns, function(col){
            return boolFields.indexOf(col.field) !== -1 && !col.hidden;
        });
        
        boolCols.forEach(function (col) {
            col.template =  MDB.KendoConfigBuilder.gridBooleanYesNoTemplate(col.field);
        });
        
        columnConfig.columns.push({
            title: 'Naar Aanvraag',
            width: 100,
            template: function (model) {
                if (model.CanEdit) {
                    return createLinkButton($gridSelector, 'view', model.Id);
                }

                return '';
            }
        });
        
        if($gridSelector.data('exportUrl')){
            columnConfig.columns.push({
                title: 'Export',
                width: 100,
                template: function (model) {
                    return createLinkButton($gridSelector, 'export', model.Id);
                }
            });
        }
        
        if (status === 0){
            columnConfig.columns.push({
                command: {
                    name: 'destroy',
                    text: '',
                    iconClass: 'grid-icon fa fa-lg fa-trash'
                },
                attributes: {
                    class: 'require-edit-right'
                },
                title: 'Verwijderen',
                width: 50
            });
        }
        
        
        var gridConfig = {
            dataSource: new kendo.data.DataSource({
                pageSize: 20,
                transport: {
                    read: function (opts) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/Requests?status=' + status, 'GET', opts);
                    },
                    destroy: function (opts) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/Requests?id=' + opts.data.Id, 'DELETE', opts);
                    }
                },
                schema: {
                    model: columnConfig.model
                }
            }),
            dataBound: function (e) {
                var ds = e.sender.dataSource
                    , table = $(e.sender.table);
                
                _.filter(ds.view(), function(item){
                    return !item.CanEdit;
                })
                    .forEach(function (item) {
                        table.find('tr[data-uid="' + item.uid + '"] .require-edit-right').each(function () {
                            var target = $(this);
                        
                            if (this.tagName === 'TD'){
                                target = target.children();
                            }
                        
                            target.hide();
                        });
                    });
            },
            pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
            columns: columnConfig.columns,
            messages: {
                commands: MDB.KendoConfigBuilder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            },
            navigatable: true,
            sortable: { mode: 'multiple' },
            scrollable: false,
            editable: 'inline'
        };
        
        
        //Only enable excel export for published offer data
        if (status === 3){
            var toolbar = gridConfig.toolbar;
            if (toolbar) {
                toolbar.push('excel');
            } else {
                toolbar = ['excel'];
            }
            
            gridConfig.toolbar = toolbar;
            
            gridConfig.excel = {
                proxyURL: '/Proxy/KendoUI',
                forceProxy: true
            };
        }
        
        return $gridSelector.kendoGrid(gridConfig);
    }
    
    function fieldsOfType(fields, type) {
        return _.map(_.filter(_.map(_.keys(fields), function(key){
            return {field: key, type: fields[key].type}
        }),  {type: type}), 'field');
    }
    
    function createLinkButton(gridSelector, linkType, id){
        var baseLink = gridSelector.data(linkType + 'Url');
        var buttonType = gridSelector.data(linkType + 'ButtonType') || gridSelector.data('buttonType');
        var buttonText = gridSelector.data(linkType + 'ButtonText') || gridSelector.data('buttonText');
        
        
        return sprintf('<a class="btn btn-%s" href="%s">%s</a>',
            buttonType,
            baseLink + '/' + id,
            buttonText
        );
    }
    
    $.extend(MDB.DPN.Offers.RequestLanding, {
        boot: function () {
            $('.request-grid').each(function () {
                createRequestGrid(this);
            });
            
            
            $('.search-offers').on('keyup', function (e) {
                if (this.lastValue === this.value) {
                    return;
                }
                
                this.lastValue = this.value;
                
                var grid = $(this).closest('.grid-container').find('.request-grid');
                
                MDB.DPN.Offers.RequestLanding.filterGrid(grid, this.value);
            });
        },
        filterGrid: function (selector, text) {
            var grid = $(selector).data('kendoGrid');
            
            var filter = {};
            
            if (!!text){
                var fields = grid.dataSource.options.schema.model.fields;

                var stringFields = fieldsOfType(fields,  'string');
                var numberFields = fieldsOfType(fields,  'number');
                var boolFields = fieldsOfType(fields,  'boolean');
                
                var trueRegex = new RegExp('^' + MDB.loadResourceString('Bool_Yes') + '$', 'i')
                    , falseRegex = new RegExp('^' + MDB.loadResourceString('Bool_No') + '$', 'i');
                
                var searchableFields = _.filter(grid.options.columns, function (item) {
                    return !item.hidden && !!item.field; 
                });
                
                searchableFields = _.filter(searchableFields, function(item){ 
                    if (stringFields.indexOf(item.field) !== -1){
                        return true;
                    }

                    if (boolFields.indexOf(item.field) !== -1){
                        var isMatch;
                        var isTrueString = false;
                        
                        if (trueRegex.test(text)){
                            isMatch = true;
                            isTrueString = true;
                        }
                        
                        if(falseRegex.test(text)){
                            isMatch = true;
                        }
                        
                        if (isMatch){
                            item.filterValue = true;
                            item.operator = isTrueString ? 'eq' : 'neq';
                        }
                        
                        return isMatch;
                    }
                    
                    if(numberFields.indexOf(item.field) !== -1){
                        if (!isNaN(text)){
                            item.filterValue = Number(text);
                            item.operator = 'eq';
                            
                            return true;
                        }
                    }
                    
                    return false;
                });
                
                var filters = _.map(searchableFields, function (item) {
                    return {
                        field: item.field,
                        operator: item.operator || 'contains',
                        value: item.filterValue || text
                    }
                });

                filter = {
                    logic: 'or',
                    filters: filters
                };   
            }
            
            grid.dataSource.filter(filter);
        }
    });
})(jQuery);